export default "Aktuell sind keine Pressemeldungen vorhanden.";